import _default from './Placeholder';
export { _default as default };